import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import Coverage from "@/components/landing/Coverage";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";

export default function LandingPage() {
    return (
        <div data-testid="landing-page" className="bg-white text-slate-900">
            <Header />
            <main>
                <Hero />
                <About />
                <Services />
                <WhyChooseUs />
                <Coverage />
                <Contact />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}
